export const is_mobile_device_server = async () => {
	const { userAgent } = require('next/server');
	const { headers } = require("next/headers");
	const request_header = await headers();
	const { device } = userAgent({ headers: request_header });
	return device.type === 'mobile'
}

export const detect_device_server = async () => {
	const { userAgent } = require('next/server');
	const { headers } = require("next/headers");
	const request_header = await headers();
	const { device } = userAgent({ headers: request_header })
	return device
}

/**
 * The device class for ImageDeviceProvider: "mobile" for phones, "desktop" for a browser without a device type,
 * undefined for tablets and others (their width can fall on either side of the site's breakpoint).
 */
export const image_device_server = async () => {
	const device = await detect_device_server();
	if (device?.type === "mobile") return "mobile";
	if (!device?.type) return "desktop";
	return undefined;
};
